import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from 'src/context/ute-auth-context/auth-provider';
import LoginLayout from 'src/modules/layout/login-layout';
import SuccessScreen from 'src/modules/third-party-login/success-screen';
import { isThirdPartyUserVerified } from 'src/modules/third-party-login/third-party-login-component-api';

const ThirdPartyAccessVerifiedContainer = () => {
		const location = useLocation();
		const queryParams = new URLSearchParams(location.search);
		const clientName = queryParams.get('clientName') ?? '';
		const isAlreadyVerified = queryParams.get('isAlreadyVerified') === 'true';
		const accessIdentifier = queryParams.get('accessIdentifier') ?? '';
		const { companyId } = useContext(AuthContext);
		const [isVerificationComplete, setIsVerificationComplete] = useState(false);
	
		useEffect(() => {
			isThirdPartyUserVerified(companyId, accessIdentifier, () => {
				setIsVerificationComplete(true);
			});
		}, [accessIdentifier]);
	return (
		isVerificationComplete && <LoginLayout>
			<SuccessScreen clientName= {clientName} isAlreadyVerified = {isAlreadyVerified}/>
		</LoginLayout>
	);
};

export default ThirdPartyAccessVerifiedContainer;
